/* @flow */

const hrefEmail = (email: string) => `<a href="mailto:${email}">${email}</a>`;

export default hrefEmail;
